import model from 'modules/webhook/webhookModel';

const { fields } = model;

export default [
  fields.url,
  fields.company,
  fields.enable,
];
